// extracted by mini-css-extract-plugin
export default {"button":"VhAiryoQcQMTjmZ3b9Ti","icon":"jxYS7YEfknJwmEwaKvk8"};